import { useInView } from 'react-intersection-observer'

import Loader from '@/components/Atoms/Loader/Loader'

import cn from './LoadMoreTrigger.module.scss'

const LOAD_MORE_ROOT_MARGIN = '200px'

type LoadMoreTriggerProps = {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  onLoadMore: () => void
}

function LoadMoreTrigger({
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
}: LoadMoreTriggerProps) {
  const { ref } = useInView({
    rootMargin: LOAD_MORE_ROOT_MARGIN,
    onChange: (inView) => {
      if (inView && hasNextPage && !isFetchingNextPage) onLoadMore()
    },
  })

  if (!hasNextPage) return null

  return (
    <div ref={ref} className={cn.trigger}>
      {isFetchingNextPage && <Loader size={20} paddingTop={0} />}
    </div>
  )
}

export default LoadMoreTrigger
